/**
 * Миксин выбора видимых колонок таблицы (по образцу admin/Point-list.vue).
 *
 * Компонент объявляет headers: [{value, text, show, active, active_temp}]
 * (show: true — колонка всегда видна и не предлагается в диалоге) и сам рисует
 * диалог (v-data-table по headers.filter(a => !a.show), чекбокс active_temp).
 *
 * Пример:
 *   import { headersMixin } from '@/views/skud/shared/modules/headers-mixin'
 *   export default { mixins: [headersMixin], data: () => ({ headers: [...] }),
 *     mounted () { this.setDefaultSkudHeaders(this.$store.state.user.skud_passage_headers) } }
 *   Таблица: :headers="headers.filter(a => a.show || a.active)"
 *   Кнопка диалога: @click="openSkudHeaders()"; «Сохранить»: saveSkudHeaders('skud_passage')
 */
export const headersMixin = {
  data () {
    return {
      dialog_headers: { show: false }
    }
  },
  methods: {
    // Применить сохранённые у пользователя колонки (массив value из store.user).
    setDefaultSkudHeaders (userHeaders) {
      if (!userHeaders || userHeaders.length === 0) return
      for (const x in this.headers) {
        this.headers[x].active = userHeaders.indexOf(this.headers[x].value) > -1
      }
    },
    openSkudHeaders () {
      for (const x in this.headers) {
        this.headers[x].active_temp = this.headers[x].active
      }
      this.dialog_headers.show = true
    },
    saveSkudHeaders (entity) {
      for (const x in this.headers) {
        this.headers[x].active = this.headers[x].active_temp
      }
      this.dialog_headers.show = false
      this.$axios.post('/api/user/headers', {
        entity: entity,
        headers: this.headers.filter(a => a.active).map(a => a.value)
      }).catch(e => {
        console.log(e)
      })
    }
  }
}

export default headersMixin
